
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","viewBox":"0 0 384 512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m368 32h4c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12h-360c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h4c0 91.821 44.108 193.657 129.646 224-85.814 30.441-129.646 132.477-129.646 224h-4c-6.627 0-12 5.373-12 12v8c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12v-8c0-6.627-5.373-12-12-12h-4c0-91.821-44.108-193.657-129.646-224 85.814-30.441 129.646-132.477 129.646-224zm-320 0h288c0 110.457-64.471 200-144 200s-144-89.543-144-200zm288 448h-288c0-110.457 64.471-200 144-200s144 89.543 144 200zm-66.34-333.088a141.625 141.625 0 0 1 -6.774 8.739c-2.301 2.738-5.671 4.348-9.248 4.348h-123.276c-3.576 0-6.947-1.61-9.248-4.348a142.319 142.319 0 0 1 -6.774-8.739c-5.657-7.91.088-18.912 9.813-18.912h135.694c9.725 0 15.469 11.003 9.813 18.912zm-171.281 269.088h187.243a12.01 12.01 0 0 1 11.602 8.903 199.464 199.464 0 0 1 2.059 8.43c1.664 7.522-4 14.667-11.704 14.667h-191.157c-7.704 0-13.368-7.145-11.704-14.667.62-2.804 1.307-5.616 2.059-8.43a12.01 12.01 0 0 1 11.602-8.903z"}})])
          )
        }
      }
    